<script setup>
// KISOFT: pagina "Meta" (Faturamento do mes x meta) reconstruida NATIVA no Chatwoot.
// Dados do endpoint publico do painel: kisoft.com.br/tarefass/painel.php?data=1
// (so percentuais: percentualMeta, variacaoMesAnterior, idealPct - nunca R$).
import { ref, onMounted, onBeforeUnmount } from 'vue';

const DATA_URL = 'https://kisoft.com.br/tarefass/painel.php?data=1';
const MESES = ['', 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const mesNome = MESES[new Date().getMonth() + 1];
const horaAgora = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

const root = ref(null);
let pollTimer = null;
let msgTimer = null;
let raf = null;
let festaAte = 0;
let lastEstado = null;
const view = { pct: 0 };
let DADOS = { percentualMeta: 0, variacaoMesAnterior: 0, idealPct: 0 };

const MSGS = {
  inicio: ['Vamos buscar essa meta! 🚀', 'Juntos chegamos lá! 💪', 'É hora de acelerar! 🔥'],
  avancando: ['Estamos avançando! 🔥', 'No caminho certo! 🚀', 'Bora manter o ritmo! 💪'],
  quase: ['FALTA POUCO! 🔥', 'Quase lá, time! 🔥', 'Foco total! 🎯'],
  batida: ['META BATIDA! Que time! 🎉'],
  superada: ['META SUPERADA! Sensacional! 🚀'],
};

const estadoDe = p =>
  p >= 100.5 ? 'superada' : p >= 100 ? 'batida' : p >= 90 ? 'quase' : p >= 70 ? 'avancando' : 'inicio';
const calc = d => {
  const p = +d.percentualMeta || 0;
  const v = d.variacaoMesAnterior == null ? 0 : +d.variacaoMesAnterior;
  return { pct: p, vari: v, restante: Math.max(0, 100 - p), estado: estadoDe(p) };
};
const fmt = v => {
  const a = Math.abs(v);
  return (a < 10 ? a.toFixed(1) : Math.round(a).toString()).replace('.', ',');
};
const anim = (a, b, dur, f) => {
  let t0 = null;
  const s = ts => {
    if (!t0) t0 = ts;
    const k = Math.min(1, (ts - t0) / dur);
    const e = 1 - Math.pow(1 - k, 3);
    f(a + (b - a) * e);
    if (k < 1) requestAnimationFrame(s);
  };
  requestAnimationFrame(s);
};

const R = 44;
const C = 2 * Math.PI * R;
let ticks = [];

const render = (d, animar) => {
  const el = root.value;
  if (!el) return;
  const $ = id => el.querySelector('#' + id);
  const c = calc(d);
  const dur = animar ? 1200 : 0;
  const rootCard = $('vgroot');
  rootCard.className = 'vgcard st-' + c.estado;
  const pc = Math.max(0, Math.min(100, c.pct));
  const prog = $('vgprog');
  prog.style.strokeDashoffset = C * (1 - pc / 100);
  const ang = (pc / 100) * 360 - 90;
  const rad = (ang * Math.PI) / 180;
  const comet = $('vgcomet');
  comet.setAttribute('cx', (50 + Math.cos(rad) * R).toFixed(2));
  comet.setAttribute('cy', (50 + Math.sin(rad) * R).toFixed(2));
  $('vgfill').style.width = pc + '%';
  $('vgknob').style.left = pc + '%';
  ticks.forEach(t => t.classList.toggle('lit', +t.getAttribute('data-p') <= c.pct + 0.01));
  el.querySelectorAll('.vg-flag').forEach(f => {
    const L = parseFloat(f.style.left);
    f.classList.toggle('lit', c.pct >= L - 0.01);
  });
  const elPct = $('vgpct');
  anim(view.pct, c.pct, dur, v => {
    elPct.textContent = Math.round(v);
  });
  view.pct = c.pct;
  const elSub = $('vgsub');
  if (c.pct >= 100) {
    const ex = c.pct - 100;
    elSub.innerHTML = ex > 0.05 ? '<span class="hl">+' + fmt(ex) + '%</span> acima da meta 🚀' : 'Meta atingida ✅';
  } else {
    elSub.innerHTML = 'Faltam <span class="hl">' + Math.round(c.restante) + '%</span> para a meta';
  }
  const ideal = d.idealPct == null ? 0 : +d.idealPct;
  const dev = c.pct - ideal;
  const idok = dev >= -0.05;
  const elIdeal = $('vgideal');
  if (ideal > 0) {
    elIdeal.style.display = '';
    elIdeal.className = 'vg-ideal ' + (idok ? 'pos' : 'neg');
    elIdeal.innerHTML = (idok ? '▲ +' : '▼ −') + fmt(dev) + '% ' + (idok ? 'acima' : 'abaixo') + ' do ideal';
  } else {
    elIdeal.style.display = 'none';
  }
  const v = c.vari;
  const elCmp = $('vgcmp');
  const elArrow = $('vgarrow');
  const elCmpTxt = $('vgcmptxt');
  elCmp.classList.remove('pos', 'neg');
  if (v < -0.05) {
    elCmp.classList.add('neg');
    elArrow.textContent = '🔻';
    elCmpTxt.textContent = fmt(v) + '% abaixo';
  } else if (v > 0.05) {
    elCmp.classList.add('pos');
    elArrow.textContent = '🟢';
    elCmpTxt.textContent = '+' + fmt(v) + '% acima';
  } else {
    elArrow.textContent = '➖';
    elCmpTxt.textContent = 'igual ao mês passado';
  }
  const arr = MSGS[c.estado] || MSGS.inicio;
  $('vgmsg').textContent = arr[Math.floor(Date.now() / 9000) % arr.length];
  if ((c.estado === 'batida' || c.estado === 'superada') && lastEstado && lastEstado !== 'batida' && lastEstado !== 'superada') festa();
  if ((c.estado === 'batida' || c.estado === 'superada') && lastEstado === null) festa();
  lastEstado = c.estado;
};

// ---- confetti / fogos (comemoracao ao bater a meta) ----
const CORES = ['#ffd166', '#7CF29A', '#5b8cff', '#22e0d8', '#ff8bd0', '#fff', '#ffe6a0'];
let parts = [];
let ctx = null;
let cv = null;
const DPR = Math.min(2, window.devicePixelRatio || 1);
const fxSz = () => {
  if (!cv) return;
  cv.width = window.innerWidth * DPR;
  cv.height = window.innerHeight * DPR;
  ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
};
const confete = n => {
  for (let i = 0; i < n; i++)
    parts.push({ t: 'c', x: Math.random() * window.innerWidth, y: -20 - Math.random() * window.innerHeight * 0.3, vx: (Math.random() - 0.5) * 2.4, vy: 2 + Math.random() * 3.6, g: 0.045 + Math.random() * 0.03, s: 5 + Math.random() * 7, rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.3, col: CORES[(Math.random() * CORES.length) | 0], life: 1, dec: 0.0015 + Math.random() * 0.0016 });
};
const fogo = () => {
  const cx = window.innerWidth * (0.2 + Math.random() * 0.6);
  const cy = window.innerHeight * (0.18 + Math.random() * 0.34);
  const col = CORES[(Math.random() * CORES.length) | 0];
  const n = 48 + ((Math.random() * 30) | 0);
  for (let i = 0; i < n; i++) {
    const a = (i / n) * 6.28;
    const sp = 1.6 + Math.random() * 3.6;
    parts.push({ t: 'f', x: cx, y: cy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, g: 0.03, s: 2.4 + Math.random() * 2, col, life: 1, dec: 0.008 + Math.random() * 0.006 });
  }
};
const fxLoop = () => {
  if (!ctx) return;
  ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
  let alive = false;
  for (let i = 0; i < parts.length; i++) {
    const p = parts[i];
    if (p.life <= 0) continue;
    alive = true;
    p.vy += p.g;
    p.x += p.vx;
    p.y += p.vy;
    p.life -= p.dec;
    if (p.t === 'c') p.rot += p.vr;
    ctx.globalAlpha = Math.max(0, p.life);
    ctx.fillStyle = p.col;
    if (p.t === 'c') {
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.62);
      ctx.restore();
    } else {
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.s, 0, 6.28);
      ctx.fill();
    }
  }
  ctx.globalAlpha = 1;
  if (parts.length > 1500) parts = parts.filter(p => p.life > 0);
  if (alive || Date.now() < festaAte) raf = requestAnimationFrame(fxLoop);
  else {
    parts = [];
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    raf = null;
  }
};
const festa = () => {
  const el = root.value;
  if (!el) return;
  const cel = el.querySelector('#vgcel');
  cel.classList.add('on');
  festaAte = Date.now() + 7000;
  confete(190);
  if (!raf) raf = requestAnimationFrame(fxLoop);
  let k = 0;
  const iv = setInterval(() => {
    fogo();
    confete(44);
    if (++k >= 8) clearInterval(iv);
  }, 640);
  setTimeout(() => cel.classList.remove('on'), 6500);
};

const puxar = () => {
  fetch(DATA_URL, { cache: 'no-store' })
    .then(r => r.json())
    .then(d => {
      if (d && !d.erro) {
        DADOS = d;
        render(d, true);
      }
    })
    .catch(() => {});
};

onMounted(() => {
  const el = root.value;
  // ticks do anel
  const g = el.querySelector('#vgticks');
  let html = '';
  for (let i = 0; i <= 20; i++) {
    const ang = (i / 20) * 360 - 90;
    const rad = (ang * Math.PI) / 180;
    const big = i % 5 === 0;
    const r1 = big ? 38.5 : 40;
    const r2 = 44.5;
    html += '<line class="tk' + (big ? ' big' : '') + '" data-p="' + i * 5 + '" x1="' + (50 + Math.cos(rad) * r1).toFixed(2) + '" y1="' + (50 + Math.sin(rad) * r1).toFixed(2) + '" x2="' + (50 + Math.cos(rad) * r2).toFixed(2) + '" y2="' + (50 + Math.sin(rad) * r2).toFixed(2) + '"/>';
  }
  g.innerHTML = html;
  ticks = [].slice.call(el.querySelectorAll('#vgticks .tk'));
  const prog = el.querySelector('#vgprog');
  prog.style.setProperty('--C', C);
  prog.style.strokeDasharray = C;
  // confetti canvas
  cv = el.querySelector('#vgfx');
  ctx = cv.getContext('2d');
  fxSz();
  window.addEventListener('resize', fxSz);
  render(DADOS, false);
  puxar();
  setTimeout(() => render(DADOS, true), 140);
  pollTimer = setInterval(puxar, 45000);
  msgTimer = setInterval(() => {
    const el2 = root.value;
    if (!el2) return;
    const c = calc(DADOS);
    const arr = MSGS[c.estado] || MSGS.inicio;
    const m = el2.querySelector('#vgmsg');
    m.style.opacity = 0;
    setTimeout(() => {
      m.textContent = arr[Math.floor(Date.now() / 9000) % arr.length];
      m.style.opacity = 0.96;
    }, 380);
  }, 9000);
});

onBeforeUnmount(() => {
  clearInterval(pollTimer);
  clearInterval(msgTimer);
  if (raf) cancelAnimationFrame(raf);
  window.removeEventListener('resize', fxSz);
});
</script>

<template>
  <div ref="root" class="kgmeta">
    <section class="vgcard st-inicio" id="vgroot">
      <div class="vgwv" />
      <div class="vg-head">
        <div class="t">
          <span class="tico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="4.5" /><circle cx="12" cy="12" r=".6" fill="currentColor" /></svg></span>
          <div>
            <h2>FATURAMENTO DE <span>{{ mesNome.toUpperCase() }}</span></h2>
            <div class="sub">Nossa meta, nosso crescimento.</div>
          </div>
        </div>
        <div class="vg-upd"><span class="d" />Dados atualizados hoje, {{ horaAgora }}</div>
      </div>
      <div class="vg-body">
        <div class="vg-ring">
          <div class="vg-halo" />
          <svg class="vgsvg" viewBox="0 0 100 100" aria-hidden="true">
            <defs><linearGradient id="vgg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="var(--ring1)" /><stop offset=".5" stop-color="var(--c2)" /><stop offset="1" stop-color="var(--ring2)" /></linearGradient></defs>
            <g id="vgticks" />
            <circle class="trk" cx="50" cy="50" r="44" /><circle class="prg" id="vgprog" cx="50" cy="50" r="44" /><circle class="cmt" id="vgcomet" cx="50" cy="6" r="2.6" />
          </svg>
          <div class="vg-txt">
            <div class="vg-cap">da meta do mês</div>
            <div class="vg-pct"><span id="vgpct">0</span><span class="sym">%</span></div>
            <div class="vg-sub" id="vgsub" />
            <div class="vg-ideal" id="vgideal" />
          </div>
        </div>
        <div class="vg-bar" id="vgtrack">
          <div class="vg-fill" id="vgfill" /><div class="vg-knob" id="vgknob" style="left:0" />
          <div class="vg-flag" style="left:25%" /><div class="vg-flab" style="left:25%">25%</div>
          <div class="vg-flag" style="left:50%" /><div class="vg-flab" style="left:50%">50%</div>
          <div class="vg-flag" style="left:75%" /><div class="vg-flab" style="left:75%">75%</div>
          <div class="vg-flag" style="left:100%" /><div class="vg-flab" style="left:100%">🏁 Meta</div>
        </div>
        <div class="vg-cmp" id="vgcmp"><span class="lab">vs. mês passado</span><span id="vgarrow">•</span><span id="vgcmptxt">—</span></div>
        <div class="vg-msg" id="vgmsg">Vamos buscar essa meta! 🚀</div>
      </div>
    </section>
    <canvas id="vgfx" />
    <div class="vgcel" id="vgcel"><div class="b">🎉 META BATIDA! 🎉</div><div class="s">PARABÉNS, TIME!</div></div>
  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@600;700;800&family=Sora:wght@700;800&display=swap');
.kgmeta{height:100%;overflow:auto;padding:18px}
.kgmeta .vgcard{position:relative;border-radius:22px;overflow:hidden;min-height:calc(100vh - 150px);display:flex;flex-direction:column;padding:clamp(18px,2.2vw,32px);
  background:radial-gradient(120% 90% at 82% -12%,rgba(91,140,255,.12),transparent 55%),linear-gradient(160deg,#141d3a,#0a0f1f);
  border:1px solid rgba(120,150,255,.14);box-shadow:0 24px 70px rgba(0,0,0,.4),inset 0 1px 0 rgba(255,255,255,.05);font-family:'Manrope',system-ui,sans-serif}
.kgmeta .vgcard *{box-sizing:border-box}
.kgmeta .vgcard .vgwv{position:absolute;inset:0;z-index:0;pointer-events:none;background:radial-gradient(40% 50% at 8% 108%,rgba(91,140,255,.16),transparent 60%),radial-gradient(38% 46% at 100% 100%,rgba(139,92,246,.15),transparent 60%)}
.kgmeta .vg-head{position:relative;z-index:2;display:flex;align-items:flex-start;justify-content:space-between;gap:16px;flex-wrap:wrap}
.kgmeta .vg-head .t{display:flex;align-items:center;gap:14px}
.kgmeta .vg-head .tico{width:52px;height:52px;border-radius:15px;display:grid;place-items:center;color:#bcd0ff;background:radial-gradient(circle at 35% 30%,rgba(91,140,255,.4),rgba(139,92,246,.25));border:1px solid rgba(120,150,255,.3)}
.kgmeta .vg-head .tico svg{width:26px;height:26px}
.kgmeta .vg-head h2{font-family:'Sora',sans-serif;margin:0;font-size:clamp(19px,2.1vw,29px);font-weight:700;letter-spacing:.01em;color:#f4f7ff}
.kgmeta .vg-head h2 span{background:linear-gradient(90deg,#5b8cff,#22e0d8);-webkit-background-clip:text;background-clip:text;color:transparent}
.kgmeta .vg-head .sub{color:#8a97b8;font-size:13.5px;font-weight:600;margin-top:3px}
.kgmeta .vg-upd{display:flex;align-items:center;gap:9px;padding:9px 14px;border-radius:12px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);font-size:12.5px;font-weight:700;color:#8a97b8}
.kgmeta .vg-upd .d{width:8px;height:8px;border-radius:50%;background:#43d675;box-shadow:0 0 0 0 rgba(67,214,117,.6);animation:vglive 2s ease-out infinite}
@keyframes vglive{0%{box-shadow:0 0 0 0 rgba(67,214,117,.5)}70%{box-shadow:0 0 0 .5em rgba(67,214,117,0)}100%{box-shadow:0 0 0 0 rgba(67,214,117,0)}}
.kgmeta .vg-body{position:relative;z-index:2;flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:clamp(10px,1.8vh,22px);padding:14px 0}
.kgmeta .vgcard{--ring1:#5b8cff;--ring2:#22e0d8;--c1:#5b8cff;--c2:#8b5cf6;--c3:#22e0d8;--glow:rgba(91,140,255,.5);--good:#43d675;--bad:#ff5d6c;--gold:#ffd166}
.kgmeta .vg-ring{position:relative;width:min(40vh,340px);aspect-ratio:1/1;display:grid;place-items:center}
.kgmeta .vg-halo{position:absolute;inset:-7%;border-radius:50%;z-index:-1;background:conic-gradient(from -90deg,var(--c1),var(--c2),var(--c3),var(--c1));filter:blur(30px);opacity:.5;animation:vgspin 18s linear infinite;mask:radial-gradient(closest-side,transparent 60%,#000 70%);-webkit-mask:radial-gradient(closest-side,transparent 60%,#000 70%)}
@keyframes vgspin{to{transform:rotate(360deg)}}
.kgmeta .vgsvg{width:100%;height:100%;transform:rotate(-90deg);overflow:visible}
.kgmeta .vgsvg .tk{stroke:rgba(255,255,255,.16);stroke-width:1.4}.kgmeta .vgsvg .tk.big{stroke:rgba(255,255,255,.32);stroke-width:2.2}.kgmeta .vgsvg .tk.lit{stroke:var(--ring2);filter:drop-shadow(0 0 4px var(--ring2))}
.kgmeta .vgsvg .trk{fill:none;stroke:rgba(255,255,255,.07);stroke-width:7}
.kgmeta .vgsvg .prg{fill:none;stroke:url(#vgg);stroke-width:9;stroke-linecap:round;stroke-dasharray:var(--C);stroke-dashoffset:var(--C);filter:drop-shadow(0 0 10px var(--glow));transition:stroke-dashoffset 1.2s cubic-bezier(.22,.61,.36,1)}
.kgmeta .vgsvg .cmt{fill:#fff;filter:drop-shadow(0 0 7px var(--ring2)) drop-shadow(0 0 14px var(--ring1));transition:transform 1.2s cubic-bezier(.22,.61,.36,1)}
.kgmeta .vg-txt{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center}
.kgmeta .vg-cap{font-size:11px;letter-spacing:.32em;text-transform:uppercase;color:#8a97b8;font-weight:700}
.kgmeta .vg-pct{font-family:'Sora',sans-serif;font-weight:700;line-height:.9;font-size:clamp(48px,7vw,88px);letter-spacing:-.03em;background:linear-gradient(180deg,#fff,#cfe0ff);-webkit-background-clip:text;background-clip:text;color:transparent}
.kgmeta .vg-pct .sym{font-size:.42em;font-weight:700;-webkit-text-fill-color:var(--ring1);vertical-align:.3em}
.kgmeta .vg-sub{font-size:14px;font-weight:700;color:#f4f7ff;margin-top:2px}.kgmeta .vg-sub .hl{color:#5b8cff}
.kgmeta .vg-ideal{font-size:12px;font-weight:700;margin-top:4px;letter-spacing:.01em}.kgmeta .vg-ideal.pos{color:#36d399}.kgmeta .vg-ideal.neg{color:#ff6b6b}
.kgmeta .vg-bar{position:relative;width:min(62%,640px);height:15px;border-radius:999px;background:rgba(255,255,255,.07);box-shadow:inset 0 1px 3px rgba(0,0,0,.4)}
.kgmeta .vg-fill{position:absolute;left:0;top:0;bottom:0;width:0;border-radius:999px;background:linear-gradient(90deg,var(--c1),var(--c2),var(--c3));box-shadow:0 0 16px var(--glow);transition:width 1.2s cubic-bezier(.22,.61,.36,1);overflow:hidden}
.kgmeta .vg-fill::after{content:"";position:absolute;inset:0;background:linear-gradient(90deg,transparent,rgba(255,255,255,.5),transparent);transform:translateX(-100%);animation:vgsheen 2.6s ease-in-out infinite}
@keyframes vgsheen{0%{transform:translateX(-100%)}60%,100%{transform:translateX(220%)}}
.kgmeta .vg-flag{position:absolute;top:50%;transform:translate(-50%,-50%);width:.42em;height:1.8em;border-radius:99px;background:rgba(255,255,255,.18);font-size:15px}
.kgmeta .vg-flag.lit{background:var(--ring2);box-shadow:0 0 9px var(--ring2)}
.kgmeta .vg-flab{position:absolute;top:calc(100% + .5em);transform:translateX(-50%);font-size:12px;font-weight:700;color:#8a97b8;white-space:nowrap}
.kgmeta .vg-knob{position:absolute;top:50%;width:22px;height:22px;border-radius:50%;transform:translate(-50%,-50%);background:radial-gradient(circle at 35% 30%,#fff,#dfeaff 40%,var(--ring1) 100%);box-shadow:0 0 0 3px rgba(255,255,255,.12),0 0 20px var(--glow);transition:left 1.2s cubic-bezier(.22,.61,.36,1)}
.kgmeta .vg-cmp{display:inline-flex;align-items:center;gap:.55em;padding:.55em 1.15em;border-radius:999px;font-size:16px;font-weight:700;background:rgba(255,255,255,.045);border:1px solid rgba(255,255,255,.08);margin-top:4px;color:#f4f7ff}
.kgmeta .vg-cmp .lab{color:#8a97b8;font-weight:700;font-size:.72em;letter-spacing:.12em;text-transform:uppercase}
.kgmeta .vg-cmp.neg{color:var(--bad);border-color:rgba(255,93,108,.38);background:rgba(255,93,108,.09)}
.kgmeta .vg-cmp.pos{color:var(--good);border-color:rgba(67,214,117,.38);background:rgba(67,214,117,.09)}
.kgmeta .vg-msg{font-family:'Sora',sans-serif;font-size:clamp(17px,2vw,26px);font-weight:700;text-align:center;opacity:.96;transition:opacity .4s;min-height:1.2em;color:#f4f7ff}
.kgmeta .vgcard.st-batida{--ring1:var(--gold);--ring2:#ffe6a0;--c1:var(--gold);--c2:#ffe6a0;--c3:#ffd166;--glow:rgba(255,209,102,.6)}
.kgmeta .vgcard.st-superada{--ring1:#7CF29A;--ring2:var(--gold);--c1:#7CF29A;--c2:var(--gold);--c3:#ffe6a0}
.kgmeta .vgcard.st-batida .vg-pct,.kgmeta .vgcard.st-superada .vg-pct{background:linear-gradient(180deg,#fff6da,#ffd166);-webkit-background-clip:text;background-clip:text}
.kgmeta .vgcard.st-quase .vg-ring{animation:vgbr 1.7s ease-in-out infinite}@keyframes vgbr{0%,100%{filter:none}50%{filter:brightness(1.09)}}
.kgmeta #vgfx{position:fixed;inset:0;z-index:70;pointer-events:none}
.kgmeta .vgcel{position:fixed;inset:0;z-index:71;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.2em;text-align:center;pointer-events:none;opacity:0;transition:opacity .5s}
.kgmeta .vgcel.on{opacity:1}
.kgmeta .vgcel .b{font-family:'Sora',sans-serif;font-weight:700;font-size:clamp(40px,9vw,120px);background:linear-gradient(120deg,#ffe6a0,#ffd166,#ffe6a0);-webkit-background-clip:text;background-clip:text;color:transparent;text-shadow:0 8px 60px rgba(255,209,102,.4)}
.kgmeta .vgcel .s{font-family:'Sora',sans-serif;font-weight:700;font-size:clamp(20px,4vw,50px);letter-spacing:.06em;color:#fff}
</style>
